import React from 'react';
import PropTypes from 'prop-types';

import { FINANCIAL, FINANCIAL_REVIEW } from 'config/formSections/financial';

import Bankruptcies from 'components/Section/Financial/Bankruptcy';
import Gambling from 'components/Section/Financial/Gambling';
import Taxes from 'components/Section/Financial/Taxes';
import Card from 'components/Section/Financial/Card';
import Credit from 'components/Section/Financial/Credit';
import Delinquent from 'components/Section/Financial/Delinquent';
import Nonpayment from 'components/Section/Financial/Nonpayment';
import FederalDebt from 'components/Section/Financial/FederalDebt';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Alimony from 'components/Section/Financial/Alimony';
import AssetSeized from 'components/Section/Financial/AssetSeized';
import ChildSupport from 'components/Section/Financial/ChildSupport';
import CivilJudgement from 'components/Section/Financial/CivilJudgement';
import Eviction from 'components/Section/Financial/Eviction';
import Foreclosure from 'components/Section/Financial/Foreclosure';
import Lien from 'components/Section/Financial/Lien';
import NonpaymentNonfederal from 'components/Section/Financial/NonpaymentNonFederal';
import Repossession from 'components/Section/Financial/Repossession';

const sectionConfig = {
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_REVIEW.name,
};

const Review = function ({
  requireFinancialBankruptcySection,
  requireFinancialGamblingSection,
  requireFinancialTaxesSection,
  requireFinancialCardSection,
  requireFinancialCreditSection,
  requireFinancialDelinquentSection,
  requireFinancialNonpaymentSection,
  requireFinancialFederalDebtSection,
  requireFinancialAlimonySection,
  requireFinancialAssetSeizedSection,
  requireFinancialChildSupportSection,
  requireFinancialCivilJudgementSection,
  requireFinancialEvictionSection,
  requireFinancialForeclosureSection,
  requireFinancialLienSection,
  requireFinancialRepossessionSection,
  requireFinancialNonpaymentNonfederalSection,
}) {
  const subsectionProps = {
    required: true,
    scrollIntoView: false,
    scrollToBottom: '',
  };

  const sectionDivider = <hr className="section-divider" />;

  return (
    <div>
      {requireFinancialBankruptcySection && (
        <span>
          <Bankruptcies {...subsectionProps} />
          {sectionDivider}
        </span>
      )}

      {requireFinancialGamblingSection && (
        <span>
          <Gambling {...subsectionProps} />
          {sectionDivider}
        </span>
      )}

      {requireFinancialTaxesSection && (
        <span>
          <Taxes {...subsectionProps} />
          {sectionDivider}
        </span>
      )}

      {requireFinancialAlimonySection && (
        <span>
          <Alimony {...subsectionProps} />
        </span>
      )}
      {requireFinancialAssetSeizedSection && (
        <span>
          <AssetSeized {...subsectionProps} />
        </span>
      )}
      {requireFinancialChildSupportSection && (
        <span>
          <ChildSupport {...subsectionProps} />
        </span>
      )}
      {requireFinancialCivilJudgementSection && (
        <span>
          <CivilJudgement {...subsectionProps} />
        </span>
      )}
      {requireFinancialEvictionSection && (
        <span>
          <Eviction {...subsectionProps} />
        </span>
      )}
      {requireFinancialForeclosureSection && (
        <span>
          <Foreclosure {...subsectionProps} />
        </span>
      )}
      {requireFinancialLienSection && (
        <span>
          <Lien {...subsectionProps} />
        </span>
      )}
      {requireFinancialRepossessionSection && (
        <span>
          <Repossession {...subsectionProps} />
        </span>
      )}
      {requireFinancialNonpaymentNonfederalSection && (
        <span>
          <NonpaymentNonfederal {...subsectionProps} />
        </span>
      )}

      {requireFinancialFederalDebtSection && (
        <span>
          <FederalDebt {...subsectionProps} />
          {sectionDivider}
        </span>
      )}

      {requireFinancialCardSection && (
        <span>
          <Card {...subsectionProps} />
          {sectionDivider}
        </span>
      )}

      {requireFinancialCreditSection && (
        <span>
          <Credit {...subsectionProps} />
          {sectionDivider}
        </span>
      )}

      {requireFinancialDelinquentSection && (
        <span>
          <Delinquent {...subsectionProps} />
          {sectionDivider}
        </span>
      )}

      {requireFinancialNonpaymentSection && <Nonpayment {...subsectionProps} />}
    </div>
  );
};

Review.propTypes = {
  requireFinancialBankruptcySection: PropTypes.bool,
  requireFinancialGamblingSection: PropTypes.bool,
  requireFinancialTaxesSection: PropTypes.bool,
  requireFinancialCardSection: PropTypes.bool,
  requireFinancialCreditSection: PropTypes.bool,
  requireFinancialDelinquentSection: PropTypes.bool,
  requireFinancialNonpaymentSection: PropTypes.bool,
  requireFinancialFederalDebtSection: PropTypes.bool,
  requireFinancialAlimonySection: PropTypes.bool,
  requireFinancialAssetSeizedSection: PropTypes.bool,
  requireFinancialChildSupportSection: PropTypes.bool,
  requireFinancialCivilJudgementSection: PropTypes.bool,
  requireFinancialEvictionSection: PropTypes.bool,
  requireFinancialForeclosureSection: PropTypes.bool,
  requireFinancialLienSection: PropTypes.bool,
  requireFinancialRepossessionSection: PropTypes.bool,
  requireFinancialNonpaymentNonfederalSection: PropTypes.bool,
};

Review.defaultProps = {
  requireFinancialBankruptcySection: true,
  requireFinancialGamblingSection: true,
  requireFinancialTaxesSection: true,
  requireFinancialCardSection: true,
  requireFinancialCreditSection: true,
  requireFinancialDelinquentSection: true,
  requireFinancialNonpaymentSection: true,
  requireFinancialFederalDebtSection: false,
  requireFinancialAlimonySection: false,
  requireFinancialAssetSeizedSection: false,
  requireFinancialChildSupportSection: false,
  requireFinancialCivilJudgementSection: false,
  requireFinancialEvictionSection: false,
  requireFinancialForeclosureSection: false,
  requireFinancialLienSection: false,
  requireFinancialRepossessionSection: false,
  requireFinancialNonpaymentNonfederalSection: false,
};

export default connectSubsection(Review, sectionConfig);
